import { downloadOrViewPdfFile } from 'utils/func';

const { downloadRegisterResultFileUpload } = require('apis/registerResult');
const { useMutation } = require('react-query');

const useDownloadRegisterResultFileUpload = (conds) =>
  useMutation(
    ({ registerResultId, filename, type }) =>
      downloadRegisterResultFileUpload(registerResultId, filename, type),
    {
      ...conds,
      onSuccess: (data, { filename }) => {
        const blob = new Blob([data?.data], { type: 'application/pdf' });
        downloadOrViewPdfFile(blob, filename, true);
      },
    }
  );

export default useDownloadRegisterResultFileUpload;
